import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import config from 'src/config';
import authService from 'src/services/auth-service';

const rawEngineBaseQuery = fetchBaseQuery({
    baseUrl: config.engineApiUrl,
    prepareHeaders: async headers => {
        const accessToken = await authService.getAccessToken();
        if (accessToken) {
            headers.set('authorization', accessToken);
        }
        return headers;
    },
});

/**
 * REST calls to digital-dashboard-engine. Sends the same Authorization shape as the Graph client when a token exists.
 * Unauthenticated requests are still sent (e.g. GET /health); authenticated routes rely on the server returning 401.
 */
const engineApiBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const result = await rawEngineBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        return {
            error: {
                ...result.error,
                message: 'Authentication required',
            },
        };
    }

    return result;
};

export default createApi({
    reducerPath: 'engineApi',
    baseQuery: engineApiBaseQuery,
    endpoints: () => ({}),
    refetchOnFocus: true,
    refetchOnReconnect: true,
    tagTypes: [
        'riskInsightsSites',
        'riskInsightsSiteStatus',
        'siteFilterOptions',
        'organisation',
        'productLicensing',
        'sites',
        'site',
        'geography',
        'activity',
        'engineApiTokens',
        'stacCollections',
        'stacItems',
    ],
});
